import actions from './actions';
import getters from './getters';
import mutations from './mutations';

export const page = {
  namespaced: true,
  state: {
    schemes: {},
    initialSchemes: {},
    models: {},
    entries: {},
    parents: {},
    main: null,
    filter: {},
    selectedItems: {
      keyValue: '',
      items: []
    }
  },
  getters,
  mutations,
  actions
};
